import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Subject } from "rxjs";

@Injectable({
  providedIn:'root'
})
export class StyleService {

  private DisablePadding = new BehaviorSubject<boolean>(false);
  DisablePadding$ = this.DisablePadding.asObservable();

  constructor() {}

  setDisablePadding(boolean: boolean){
    this.DisablePadding.next(boolean);
  }
}
